<template>
	<div>
		<div class="mt-30">
			<nuxt-page />
		</div>
		<footer-base />
	</div>
</template>

<script lang="ts" setup></script>

<style></style>
